const intro = {
  en: {
    merchants: (
      <>
        Merchants listed on the site are validated based on internal data on a
        semi- annual basis and are subject to change during such validation
        periods.Please note that merchant information may contain inaccuracies
        or errors which may be the result of information provided by third
        parties.
      </>
    ),
    copyright: "DFS Services LLC",
    twitterMessage: "Connect with us on Twitter",
    linkedInMessage: "Connect with us on LinkedIn",
    youtubeMessage: "Visit us on YouTube",
    facebookMessage: "Connect with us on Facebook",
  },
  es: {},
};

export default intro;
